import { ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import useAuthorization from "../../lib/hooks/useAuthorization";

/**
 * MenuItem component for rendering a single menu item in the navigation
 * @param {string} to - The route path for the menu item
 * @param {React.ReactNode} icon - The icon component to display
 * @param {string} label - The text label for the menu item
 * @param {string[]} [roles] - Optional roles required to see this item
 */
function MenuItem({ to, icon, label, roles }) {
  const { authorized } = useAuthorization(roles || []);
  if (roles?.length && !authorized) {
    return null;
  }

  return (
    <Tooltip title={label} disableInteractive>
      <ListItemButton component={Link} to={to}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={label} />
      </ListItemButton>
    </Tooltip>
  );
}

export default MenuItem;
